// Modül Bazlı Lisanslama — Ruling 67: koltuk 403'ünde (`license.seatUnavailable`, RequireModuleSeat)
// kendini-onarma AÇIK ama SINIRLI — modül başına 10 dakikada en fazla BİR refresh-session.
//
// NEDEN AÇIK: web'de cookie'yi yalnız login, kiracı değişimi ve 403 self-heal'i yeniden yazar
// ("doğal yenileme" yok). Koltuk oturum ortasında VERİLDİĞİNDE (PM dönem aktivasyonu, FIFO
// terfisi, EA ataması, elle verme) ya da limit KALDIRILDIĞINDA eski token `meteredModule` taşır,
// `seat` taşımaz; onarım olmasaydı kullanıcı yeniden girişe kadar (beni hatırla: 30 gün) 403 alırdı.
// NEDEN SINIRLI: koltuğu gerçekten olmayan kişi için onarım (SwitchTenant + /me — en pahalı auth
// çağrısı) her istekte boşuna koşardı. Kendiliğinden çağrıları arayüzün hasSeat kapıları zaten
// kesiyor (P3Ö-3); onarım yalnız DURUM DEĞİŞTİĞİNDE gerekir — modül başına 10 dakikada bir yeter.
//
// Sayaç: bellek (sekme ömrü) + sessionStorage (sayfa yenilemesinde korunur; sekmeye özel). Depolama
// erişimi try/catch'li: özel pencere / engellenmiş site verisi / önizleme ortamında atar — o zaman
// yalnız bellek sayacı çalışır. Modül kodu 403 gövdesinin `data.module` alanından gelir
// (RequireModuleSeatAttribute); yoksa tek ortak anahtar ('*') kullanılır.
export const SEAT_SELF_HEAL_WINDOW_MS = 10 * 60 * 1000;

const STORAGE_PREFIX = 'flexbee.seatSelfHeal.';

function defaultStorage() {
  return typeof window !== 'undefined' ? window.sessionStorage : null;
}

export function createSeatSelfHealThrottle({
  windowMs = SEAT_SELF_HEAL_WINDOW_MS,
  getStorage = defaultStorage,
  now = () => Date.now(),
} = {}) {
  const memory = new Map();

  return {
    // true → bu modül için onarım ŞİMDİ çalışabilir (ve an kaydedilir); false → pencere dolmadı.
    tryAcquire(moduleCode) {
      const key = typeof moduleCode === 'string' && moduleCode.length > 0 ? moduleCode : '*';
      const t = now();

      let last = memory.get(key) || 0;
      try {
        const stored = Number(getStorage()?.getItem(STORAGE_PREFIX + key));
        if (Number.isFinite(stored) && stored > last) last = stored;
      } catch {
        // depolama erişilemez — yalnız bellek sayacı
      }

      // Gelecekteki damga (saat geri alındı) pencereyi süresiz kilitlemesin: süresi dolmuş sayılır.
      if (last > 0 && t >= last && t - last < windowMs) return false;

      memory.set(key, t);
      try {
        getStorage()?.setItem(STORAGE_PREFIX + key, String(t));
      } catch {
        // depolama erişilemez — yalnız bellek sayacı
      }
      return true;
    },
  };
}

export const seatSelfHealThrottle = createSeatSelfHealThrottle();
